import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

interface ProtectedRouteProps {
  children: ReactNode;
  isAuthenticated: boolean;
}

export default function ProtectedRoute({ children, isAuthenticated }: ProtectedRouteProps) {
  if (!isAuthenticated) {
    console.log('🚫 User not authenticated, redirecting to login...');
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}

